import { useTheme } from 'styled-components'

import { useIntl } from 'react-intl'
import { LuInfo } from 'react-icons/lu'

import { Infobox } from '@/lib/core/components/Infobox'
import { SimpleModal, SimpleModalProps } from '@/lib/core/components/Modal'
import messages from '@/lib/core/components/Modal/Modal.messages'

export type WarningModalProps = SimpleModalProps

export const WarningModal = ({ children, ...props }: WarningModalProps) => {
  const { colors } = useTheme()
  const { formatMessage } = useIntl()

  return (
    <SimpleModal
      cancelLabel={formatMessage(messages.stop)}
      confirmLabel={formatMessage(messages.continue)}
      headingIcon={<LuInfo size="48" color={colors.warning} strokeWidth={1.6} />}
      {...props}
    >
      <Infobox variant="warning">{children}</Infobox>
    </SimpleModal>
  )
}
